/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {Removal} from '../../../_models/removal';
import {Animal} from '../../../_models/animal';
import {DATE_TIME_FR_FORMAT, DATE_TIME_SQL_FORMAT} from '../../../_enums/constants';
import moment from "moment";

@Component({
  selector: 'app-adapter-removal-pending',
  templateUrl: './adapter-removal-pending.component.html',
  styleUrls: ['./adapter-removal-pending.component.scss']
})
export class AdapterRemovalPendingComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: Removal;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string) {
  }

  ngOnInit(): void {
    moment.locale(this.locale);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get animals(): Animal[] {
    return this.data && this.data.animals ? this.data.animals : [];
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              OTHER PUBLIC METHODS                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public formatDate(d?: string | Date): string {
    return d ? moment(d, DATE_TIME_SQL_FORMAT).format(DATE_TIME_FR_FORMAT) : '';
  }

}
